import React from 'react';
import { useTranslation } from 'react-i18next';

import { Carousel } from 'components';

import imgAssistant1En from 'images/img-ninebarc-assistant-1-en.png';
import imgAssistant2En from 'images/img-ninebarc-assistant-2-en.png';
import imgAssistant3En from 'images/img-ninebarc-assistant-3-en.png';
import imgAssistant1De from 'images/img-ninebarc-assistant-1-de.png';
import imgAssistant2De from 'images/img-ninebarc-assistant-2-de.png';
import imgAssistant3De from 'images/img-ninebarc-assistant-3-de.png';

const ITEM_KEYS = {
  INIT_QUESTIONNAIRE: 'initialQuestionnaire',
  GUIDANCE: 'guidance',
  EASY: 'easyToUse',
};

const carouselBreakPoints = [
  {
    width: 1,
    itemsToShow: 1,
    itemsToScroll: 1,
    initialActiveIndex: 0,
  },
];

interface AssistantSectionProps {
  english: boolean;
}

const AssistantSection = ({ english }: AssistantSectionProps) => {
  const { t } = useTranslation(['b2cHowPage']);

  const items = [
    {
      key: ITEM_KEYS.INIT_QUESTIONNAIRE,
      title: t('b2cHowPage:assistant_section_content_1_title'),
      content: t('b2cHowPage:assistant_section_content_1_description'),
      image: english ? imgAssistant1En : imgAssistant1De,
    },
    {
      key: ITEM_KEYS.GUIDANCE,
      title: t('b2cHowPage:assistant_section_content_2_title'),
      content: t('b2cHowPage:assistant_section_content_2_description'),
      image: english ? imgAssistant2En : imgAssistant2De,
    },
    {
      key: ITEM_KEYS.EASY,
      title: t('b2cHowPage:assistant_section_content_3_title'),
      content: t('b2cHowPage:assistant_section_content_3_description'),
      image: english ? imgAssistant3En : imgAssistant3De,
    },
  ];

  return (
    <div className="t-mt-16 md:t-mt-40 t-mb-28" id="AssistantSection">
      <div className="t-flex t-flex-col t-items-center t-text-center t-mb-10">
        <p className="Typography Typography--landingMainTitle u-weight-700">
          {t('b2cHowPage:assistant_section_title')}
        </p>

        <p className="Typography Typography--landingTitle t-text-delta-700 t-font-semibold">
          {t('b2cHowPage:assistant_section_subtitle')}
        </p>

        <hr className="t-border t-border-beta-500 t-bg-beta-500 t-w-20 t-my-6" />

        <p className="Typography Typography--landingSubTitle t-max-w-md">
          {t('b2cHowPage:assistant_section_description')}
        </p>
      </div>

      <Carousel
        breakPoints={carouselBreakPoints}
        adjustedBtnTop={64}
        adjustedBtnSide={8}
        adjustedBtnSideLeft={0.5}
        edgeButtonEnabled={true}
      >
        {items.map(({ key, title, content, image }) => (
          <div
            key={key}
            className="t-w-full t-flex t-flex-col md:t-flex-row md:t-items-center t-my-6 t-outline-none"
          >
            <div className="t-flex t-justify-center t-items-center md:t-w-136 md:t-mx-20">
              <img
                src={image}
                alt="Legacy plan features"
                className="t-max-h-96 md:t-max-h-136"
              />
            </div>
            <div className="t-text-center t-mt-10 md:t-max-w-128 md:t-text-left md:t-mt-0">
              <p className="Typography Typography--title t-font-semibold t-text-delta-700">
                {title}
              </p>
              <p className="Typography Typography--normalText t-mt-12">
                {content}
              </p>
            </div>
          </div>
        ))}
      </Carousel>

      <div className="t-flex t-justify-center t-mt-16">
        <a
          href="https://app.ninebarc.de/register"
          className="Button Button--primary Button--large t-uppercase"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('b2cHowPage:assistant_section_sign_up_button')}
        </a>
      </div>
    </div>
  );
};

export default AssistantSection;
